import { useEffect, useState } from 'react';
import './minhas-compras.component.scss';
import '../pacotes-pontos-component/pacotes-pontos.component.scss';
import '../loja-component.scss';
import { useNavigate } from 'react-router-dom';
import { RespostaTodasAsComprasSolicitadasDTO } from '../../../dtos/RespostaTodasAsComprasSolicitadasDTO';
import { buscarComprasSolicitadas } from '../../../services/busca-compras-solicitadas';
import { obterSenhaSessao, obterUsuarioSessao } from '../../../services/salva-credenciais';
import { alertService } from '../../../services/alertService';
import { useTranslation } from 'react-i18next';

const MinhasComprasComponent = () => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [carregouCompras, setCarregouCompras] = useState(false);
    const [compras, setCompras] = useState<Array<RespostaTodasAsComprasSolicitadasDTO>>([]);

    useEffect(() => {
        buscarComprasSolicitadas(obterUsuarioSessao()!, obterSenhaSessao()!)
            .then((resposta) => {

                const ordenado = [...resposta].sort((a, b) => {
                    const dataA = new Date(a.DataSolicitacao!).getTime();
                    const dataB = new Date(b.DataSolicitacao!).getTime();
                    return dataB - dataA;
                });

                setCompras(ordenado);
                setCarregouCompras(true);
            })
            .catch(() => {
                alertService.toast(t("MY_PURCHASES_FETCH_ERROR"), 'error');
            });
    }, [t]);

    const locale = i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US';

    return (
        <div className="minhas-compras-component">

            <div className="row ajuste-header-mobile">
                <div className="col-12 text-right">
                    <h6 className="sair" onClick={() => navigate('/loja')}>
                        {t("MY_PURCHASES_CLOSE")}
                    </h6>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <h3 className="text-center">
                        {t("MY_PURCHASES_TITLE")}
                    </h3>
                    <p className="text-center text-muted">
                        {t("MY_PURCHASES_SUBTITLE")}
                    </p>
                </div>
            </div>

            <br />

            {!carregouCompras && compras.length === 0 && (
                <div className="row">
                    <div className="col-12 text-center">
                        <span>{t("MY_PURCHASES_LOADING")}</span>
                    </div>
                </div>
            )}

            {carregouCompras && compras.length === 0 && (
                <div className="row">
                    <div className="col-12 text-center">
                        <span>{t("MY_PURCHASES_EMPTY")}</span>
                    </div>
                </div>
            )}

            {carregouCompras && compras.length > 0 && (
                <div className="row tabela-scroll">
                    <div className="col-12">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr>
                                    <th>{t("MY_PURCHASES_TABLE_PACKAGE")}</th>
                                    <th>{t("MY_PURCHASES_TABLE_PRICE")}</th>
                                    <th>{t("MY_PURCHASES_TABLE_POINTS")}</th>
                                    <th>{t("MY_PURCHASES_TABLE_REQUEST_DATE")}</th>
                                    <th>{t("MY_PURCHASES_TABLE_CONFIRMATION")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {compras.map((p, i) => (
                                    <tr key={i}>
                                        <td>{p.Titulo}</td>
                                        <td>{p.Preco}</td>
                                        <td>{p.TotalPontos}</td>
                                        <td>
                                            {p.DataSolicitacao
                                                ? new Date(p.DataSolicitacao).toLocaleString(locale)
                                                : ''}
                                        </td>
                                        <td>
                                            {p.DataDeConfirmacao == null ? (
                                                <span
                                                    title={t("MY_PURCHASES_WAITING_CONFIRMATION")}
                                                    className="badge badge-secondary ml-2"
                                                >
                                                    {t("MY_PURCHASES_WAITING_CONFIRMATION")}
                                                </span>
                                            ) : (
                                                new Date(p.DataDeConfirmacao).toLocaleString(locale)
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

        </div>
    );
};

export { MinhasComprasComponent };
